import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import { Cross, LayoutDashboard, Settings, LogOut, Moon, Sun, QrCode, CalendarDays, Printer, FolderArchive, HeartPulse, ShieldCheck, BarChart3 } from "lucide-react";

export function StaffHeader() {
  const { user, logout, isAdmin, isPharmacist } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = async () => { await logout(); navigate("/login"); };
  const NavLink = ({ to, icon: Icon, label, testid }) => (
    <Link to={to} data-testid={testid}
      className={`inline-flex shrink-0 whitespace-nowrap items-center gap-2 h-10 px-3.5 rounded-xl text-sm font-medium transition-colors ${pathname === to ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"}`}>
      <Icon className="h-4 w-4" aria-hidden="true" /> {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-30 border-b bg-background/85 backdrop-blur-xl">
      <div className="mx-auto max-w-[1440px] px-4 h-16 flex items-center gap-3">
        <div className="flex items-center gap-2.5 mr-2">
          <div className="h-9 w-9 rounded-xl bg-primary grid place-items-center text-primary-foreground"><Cross className="h-5 w-5" /></div>
          <div className="hidden sm:block"><div className="font-heading font-bold leading-tight">Espace officine</div><div className="text-[11px] text-muted-foreground">Pharmacie des Écoles</div></div>
        </div>
        <nav className="flex-1 min-w-0 flex items-center gap-1.5 overflow-x-auto">
          <NavLink to="/dashboard" icon={LayoutDashboard} label="Tableau de bord" testid="nav-dashboard" />
          <NavLink to="/equipe/calendrier" icon={CalendarDays} label="Cabines" testid="nav-calendrier" />
          <NavLink to="/equipe/statistiques" icon={BarChart3} label="Statistiques" testid="nav-statistiques" />
          {isPharmacist && <NavLink to="/equipe/bilans" icon={FolderArchive} label="Bilans" testid="nav-bilans" />}
          {isPharmacist && <NavLink to="/equipe/fiche-bilan" icon={Printer} label="Fiche bilan" testid="nav-fiche-bilan" />}
          {isPharmacist && <NavLink to="/equipe/consentements" icon={ShieldCheck} label="Consentements" testid="nav-consentements" />}
          <NavLink to="/affiche" icon={QrCode} label="Affiche téléconsult" testid="nav-poster" />
          <NavLink to="/affiche-bilan" icon={HeartPulse} label="Affiche bilan" testid="nav-poster-bilan" />
          {isAdmin && <NavLink to="/equipe/qr-codes" icon={QrCode} label="QR Codes" testid="nav-qrcodes" />}
          {isAdmin && <NavLink to="/admin" icon={Settings} label="Administration" testid="nav-admin" />}
        </nav>
        <div className="ml-auto shrink-0 flex items-center gap-2">
          <span className="hidden md:inline text-sm text-muted-foreground">Compte {user?.role}</span>
          <Button variant="ghost" size="icon" onClick={toggle} data-testid="theme-toggle" className="rounded-xl" aria-label="Changer de thème">
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>
          <Button variant="outline" onClick={doLogout} data-testid="logout-btn" className="rounded-xl gap-2 h-10"><LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Déconnexion</span></Button>
        </div>
      </div>
    </header>
  );
}
